import { sportGamesStatusOptions, sportPositionValidator, sportStatusOptions } from "../sports/shared";

export const marketGroupStatusOptions = sportStatusOptions;
export const marketGroupGamesStatusOptions = sportGamesStatusOptions;
export const marketGroupPositionValidator = sportPositionValidator;

export const marketGroupTypeOptions = [
  { value: 1, title: "market.group_types.admin_display" },
  { value: 2, title: "market.group_types.offer_display" },
];

export const marketGroupDisplayModeTypeOptions = [
  { value: 1, title: "market.group_display_mode_types.standard" },
  { value: 2, title: "market.group_display_mode_types.related" },
  { value: 3, title: "market.group_display_mode_types.bet_builder" },
];

export const marketGroupTagOptions = [
  { value: 1, title: "market.group_tags.promo" },
  { value: 2, title: "market.group_tags.cashout" },
];

export const MARKET_GROUP_PLAYER_PROPS_CONFIG_ID = "eventviewMarketGroupPlayerPropsMode";

export const marketGroupPlayerPropsOptions = [
  { value: true, title: "common.status.enabled" },
  { value: false, title: "common.status.disabled" },
];
